import React, { useState } from 'react'
import { Col, Form, Icon, Input, Modal, Row, Select, Upload } from 'antd'
import { useDispatch } from 'react-redux'
import { saveBarcodeProduct } from '../../../../modules/barcodeProduct'
import { saveSelectedList } from '../../../../modules/material'
import {
  beforeUpload,
  compressFile,
  getBase64
} from '../../../../utils/services'

const AddBarcodeProduct = (props) => {
  const { visible, onClose, form, values, refetchData } = props
  const { validateFields, getFieldDecorator, resetFields } = form
  const  barcodeProductCategories  = values

  const [loading, setLoading] = useState(false)
  const [imageUrl, setImageUrl] = useState('')
  const [file, setFile] = useState(null)

  const dispatch = useDispatch()

  const uploadButton = (
    <div>
      <Icon type={loading ? 'loading' : 'plus'} />
      <div className="ant-upload-text">Upload</div>
    </div>
  )
  console.log(barcodeProductCategories)

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const formData = new FormData()
        formData.append('name', values.barcodeProductName)
        formData.append('barcode', values.barcodeNo)
        formData.append('brand', values.brand)
        formData.append('barcodeCategoryId', values.barcodeCategoryId)
        formData.append('image', await compressFile(file))

        await dispatch(saveBarcodeProduct(formData, 'create'))
        await dispatch(saveSelectedList([]))
        await resetFields()
        await onClose()
        await setFile(null)
        await setImageUrl('')
        await refetchData()
      }
    })
  }

  const handleChange = async (info) => {
    await setLoading(true)
    await getBase64(info.file, (imageUrl) => {
      setLoading(false)
      setImageUrl(imageUrl)
    })
  }

  const onCancel = async () => {
    await onClose()
    await setFile(null)
    await setImageUrl('')
  }

  return (
    <Modal
      visible={visible}
      title="Create a new BarcodeProduct"
      okText="Create"
      onCancel={onCancel}
      onOk={onSubmit}>
      <Form>
        <Form.Item label="ชื่อ BarcodeProduct">
          {getFieldDecorator('barcodeProductName', {
            rules: [{ required: true, message: 'กรุณาใส่ชื่อ BarcodeProduct' }]
          })(
            <Input
              name="barcodeProductName"
              placeholder="BarcodeProduct Name"
            />
          )}
        </Form.Item>
        <Form.Item label="Barcode No.">
          {getFieldDecorator('barcodeNo', {
            rules: [{ required: true, message: 'กรุณาใส่ชื่อ Barcode No.' }]
          })(<Input name="barcodeNo" placeholder="Barcode No." />)}
        </Form.Item>
        <Form.Item label="ยี่ห้อสินค้า">
          {getFieldDecorator('brand', {
            rules: [{ required: true, message: 'กรุณาใส่ชื่อยี่ห้อสินค้า' }]
          })(<Input name="brand" placeholder="ยี่ห้อสินค้า" />)}
        </Form.Item>
        <Form.Item label="หมวดหมู่">
          {getFieldDecorator('barcodeCategoryId', {
            rules: [{ required: true, message: 'กรุณาเลือกหมวดหมู่' }]
          })(
            <Select>
              {barcodeProductCategories &&
                barcodeProductCategories.map((item) => {
                  return (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  )
                })}
            </Select>
          )}
        </Form.Item>
        <Form.Item label="รูปหน้าปก">
          {getFieldDecorator('cover', {
            rules: [{ required: true, message: 'กรุณาเลือกรูปหน้าปก' }]
          })(
            <Row type="flex" justify="center">
              <Col>
                <Upload
                  name="avatar"
                  listType="picture-card"
                  style={{ width: 128, height: 128 }}
                  showUploadList={false}
                  beforeUpload={(file) => beforeUpload(file, setFile)}
                  onChange={handleChange}>
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="avatar"
                      style={{ width: '100%' }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </Col>
            </Row>
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}

const WrappedAddBarcodeProduct = Form.create({
  name: 'AddBarcodeProduct'
})(AddBarcodeProduct)

export default WrappedAddBarcodeProduct



// WEBPACK FOOTER //
// ./src/pages/BarcodeProduct/components/AddBarcodeProduct/index.js